/* global document, CustomEvent */
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "toggle", "toggleable", "requiredField"];

  static values = {
    checked: Boolean,
  };

  connect() {
    this.checkedValueChanged(this.checkedValue);
  }

  checkedValueChanged(newValue) {
    this.element.setAttribute("aria-checked", newValue);
    this.inputTarget.checked = newValue;
    this.toggleRequiredFields(newValue);
  }

  toggleRequiredFields(isVisible) {
    this.requiredFieldTargets.forEach((field) => {
      if (isVisible) {
        field.setAttribute("required", "required");
      } else {
        field.removeAttribute("required");
      }
    });
  }

  toggle() {
    this.checkedValue = !this.checkedValue;

    const event = new CustomEvent("toggle:click", {
      detail: {
        element: this.element,
        target: this.inputTarget,
        checked: this.checkedValue,
      },
    });

    document.dispatchEvent(event);
  }
}
